/**
 *=================================== AUTHOR : MUSKAN KHAN===========================
 * ===================================DATE : 10 OCT 2024========================
 */
import SparkApi from "../../api/SparkApi";
import { ToastContainer, toast } from "react-toastify";
import { Button, Col, Container, Row, Table } from "react-bootstrap";
import { DatatableWrapper, Filter, Pagination, PaginationOptions, TableBody, TableHeader } from "react-bs-datatable";
import { useState, useEffect } from "react";
import InfoPill from "../InfoPill";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import CreateProductCategoryModal from "./CreateProductCategoryModal";
import Confirm from "../Confirm";
import { usePermission } from "../context/PermissionContext";

const Productcategoryview = () => {
  const [productcategory, setProductCategory] = useState([]);
  const [rowRecord, setRowRecord] = useState();
  const [showModal, setShowModal] = useState(false);
  const [deleleteCategoryRecord, setDeleleteCategoryRecord] = useState(false);
  const [body, setBody] = useState();
  const { permissionData , userInfo} = usePermission();
  const can_create = permissionData?.Product_Category?.can_create;
  const can_edit = permissionData?.Product_Category?.can_edit;
  const can_delete = permissionData?.Product_Category?.can_delete;

  useEffect(() => {
    fetchProductsCategory();
  }, []);

  const fetchProductsCategory = async () => {
    try {
      const result = await SparkApi.getProductCategory();
      if (result.success) {
        setProductCategory(result.records);
        setBody(result.records);
      } else {
        setProductCategory([]);
      }
    } catch (error) {
      setProductCategory([]);
    }
  };

  const capitalizeWords = (str) => {
    return str ? str.replace(/\b\w/g, (char) => char.toUpperCase()) : "";
  };

  const labels = { beforeSelect: " " };

  const header = [
    {
      title: "Category Name",
      prop: "category",
      isFilterable: true,
      isSortable:true,
    },
    {
      title: "Status",
      prop: "status",
      isSortable:true,
      isFilterable: true,
      cell: (row) => <>
          <span 
            className={`badge px-3 py-2 text-white ${row?.status === 'active' ? 'bg-success' : 'bg-danger'}`}
            style={{ minWidth: "80px", textAlign: "center" }}
          >
            {row?.status === 'active' ? 'Active' : 'InActive'}
          </span>
      </>,
    },
    (userInfo?.userrole === "ADMIN" || can_edit || can_delete) &&
    {
      title: "Actions",
      prop: "",
      cell: (row) => (
        <>
          {(userInfo?.userrole === "ADMIN" || can_edit) &&
            (<Button className="btn-sm" variant="primary" onClick={() => handleEdit(row)}>
              <FontAwesomeIcon icon={faEdit} />
            </Button>
          )}
          {(userInfo?.userrole === "ADMIN" || can_delete) && 
            (<Button
              className="btn-sm mx-2"
              variant="danger"
              onClick={() => handleDelete(row)}
            >
              <FontAwesomeIcon icon={faTrash} />
            </Button>
          )}
        </>
      ),
    }
  ].filter(Boolean);

  const closeModal = () => {
    setShowModal(false);
    setRowRecord();
    fetchProductsCategory();
    setDeleleteCategoryRecord(false);
  };

  const handleEdit = (row) => {
    setRowRecord(row);
    setShowModal(true);
  };

  const createProductCategory = () => {
    setShowModal(true);
  };

  const handleDelete = async (row) => {
    setDeleleteCategoryRecord(true);
    setRowRecord(row);
  };

  const errorToastMessage = {
    width: "350px",
    color: "red",
  }

  const handleDeleteProCategory = async () => {
    try {
      const result = await SparkApi.deleteProductCategory(rowRecord.id);
      if (result.success) {
        closeModal();
        return toast.success("Record deleted successfully");
      } else {
        // toast.error("Failed to delete product");
        toast.error(result?.error, {
          style : errorToastMessage,
        });
      }
    } catch (error) {
      console.error("Error deleting product:", error);
    }
  };

  return (
    <>
      {deleleteCategoryRecord && (
        <Confirm
          show={deleleteCategoryRecord}
          onHide={closeModal}
          handleDeleteProCategory={handleDeleteProCategory}
          title="Confirm delete?"
          message="You are going to delete the record. Are you sure?"
          table="productcategory"
        />
      )}

      {showModal && (
        <CreateProductCategoryModal
          show={showModal}
          onHide={closeModal}
          recordForUpdate={rowRecord}
        />
      )}

      <Container>  
        <Row className="g-0">
          <Col lg={12}>
            <DatatableWrapper
              body={productcategory}
              headers={header}
              paginationOptionsProps={{
                initialState: {
                  rowsPerPage: 10,
                  options: [5, 10, 15, 20],
                },
              }}
            >
              <Row className="mb-4">
                <Col xs={12} lg={4} sm={4} className="d-flex flex-col justify-content-end align-items-end">
                  <Filter />
                </Col>
                <Col xs={9} sm={6} lg={4} className="d-flex flex-col justify-content-start align-items-start">
                  <PaginationOptions labels={labels} />
                  <div className="mt-2">
                    <InfoPill
                      className="d-flex flex-col justify-content-start align-items-start"
                      left="Total Category"
                      right={body ? body.length : 0}
                    />
                  </div>
                </Col>
                <Col xs={3} sm={2} lg={4} className="d-flex flex-col justify-content-end align-items-end">
                  {(userInfo?.userrole === "ADMIN" || can_create) && 
                    (<Button
                      className="btn-sm custom-btn-css-add-new-record"
                      variant="outline-primary"
                      onClick={createProductCategory}
                    >
                      New Category
                    </Button>
                  )}
                </Col>
              </Row>

              <Table striped className="data-table" responsive="sm">
                <TableHeader />
                <TableBody />
              </Table>
              <Pagination />
            </DatatableWrapper>
          </Col>
        </Row>
      </Container>

      <ToastContainer
        position="top-center"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
};

export default Productcategoryview;